import './Home.css';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function Home() {
  const classes = useStyles();

  return (
    <div
      style={{
        margin: 0,
        display: 'inline-block',
        textAlign: 'left',
      }}
    >
      <h1>Home</h1>
    </div>
  );
}

export default Home;
